import script from "./ClassComparisonBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassComparisonBarChart.vue?vue&type=script&setup=true&lang=js"

import "./ClassComparisonBarChart.vue?vue&type=style&index=0&id=1f811126&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f811126"]])

export default __exports__